import { ingenuity, dispatcher, IEvent, Loading, BaseCoreConstants, EventConstants, delayedCall, killDelayedCall, IObject } from "@quest/base-core";
import { GameLogic, SlotEventConstantsBehavior, winMeterBg, FreeGameModelBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { SlotConstants } from "@quest/slot-core/dist/SlotConstants/SlotConstants";
import { SlotEventConstants } from "@quest/slot-core";
import { SlotConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-leopard/dist";
import { Model as platformModel } from "@quest/platform-murka/dist";
import { EventConstants as PlatformEventConstants } from "@quest/platform-core/dist/Base/EventConstants";
import { EventConstantsLeander } from "@quest/oddsworks-platform/dist";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { gameConstants } from "../Constants/gameConstants";
import { MeterGame } from "../UI/MeterGame";

export class GameClientLogic extends GameLogic {

  private spinSoundPause: boolean = false;

  /**
   * Method Overrided to add SHOW_OUTRO_AFTER_FG
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_OUTRO_AFTER_FG, this.showOutroAfterFg, this);
    dispatcher.off(SlotEventConstants.FG_SCATTER_ANIMATION_ENDED, this.startRetriggerInitialization, this);
    dispatcher.on(SlotEventConstants.FG_SCATTER_ANIMATION_ENDED, this.showNextWinPresentation, this);
  }

  /**
   * Method Overrided to add SHOW_OUTRO_AFTER_FG
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.SHOW_OUTRO_AFTER_FG, this.showOutroAfterFg, this);
  }

  /**
   * Method Overrided to add presentations
   */
  protected onShowNextWinPresentation(evt?: IEvent): void {
    const winSequenceCounter = this.model.getAnimationSequenceCounter(); // animation sequence counter , which increase its value agter every win sequence execution
    if (winSequenceCounter >= this.model.getAnimationSequence().length) {
      return;
    }
    const sequenceArray = this.model.getAnimationSequence(); // animation sequence array
    const currentWinEventToShow = sequenceArray[winSequenceCounter]; // current win presentation to show from win sequence
    switch (currentWinEventToShow) {
      case "stackSymbol":
        this.updateAnimationSequenceCounter(); // update sequnce number after every current sequence pick and to execute next sequence
        this.onShowStackSymbol();
        break;
      case "magicPotionWithPrize":
        this.updateAnimationSequenceCounter(); // update sequnce number after every current sequence pick and to execute next sequence
        this.magicPotionPrizePresentation();
        break;
      case "magicPotionWithJackpot":
        this.updateAnimationSequenceCounter(); // update sequnce number after every current sequence pick and to execute next sequence
        this.magicPotionWithJackpotPresentation();
        break;
      case "sendCloseRequest":
        this.updateAnimationSequenceCounter(); // update sequnce number after every current sequence pick and to execute next sequence
        this.sendCloseRequest();
        break;
      case "jackpotTopPanelAnim":
        this.updateAnimationSequenceCounter(); // update sequnce number after every current sequence pick and to execute next sequence
        this.jackpotTopPanelAnim();
        break;
      case "jackpotBannerPresentation":
        this.updateAnimationSequenceCounter(); // update sequnce number after every current sequence pick and to execute next sequence
        this.showJackpotBannerPresentation();
        break;
      case "fsPotSymbolConversion":
        this.updateAnimationSequenceCounter(); // update sequnce number after every current sequence pick and to execute next sequence
        this.fsPotSymbolConversion();
        break;
      case "freeSpin":
        this.updateAnimationSequenceCounter(); // update sequnce number after every current sequence pick and to execute next sequence
        if (!winMeterBg.getIsTickUpRunning()) {
          this.onFreeSpinPresentation();
        }
        else {
          winMeterBg.setTickupCallBack(this.onFreeSpinPresentation.bind(this));
        }
        break;
      default:
        super.onShowNextWinPresentation(evt);
        break;
    }
  }

  /**
   * Method onShowStackSymbol overrided to update functionality
   *  - to add stack symbol
   */
  private onShowStackSymbol(): void {
    if ((ingenuity.parserModel as GameParserModel).getHasLineWins() && (ingenuity.parserModel as GameParserModel).getStackSymPresent() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_BASEGAME_STACK_FEATURE);
      dispatcher.fireEvent(eventDispatchers.SHOW_LARGE_STACK_SYMBOL);
    }
    else if ((ingenuity.parserModel as GameParserModel).getHasLineWins() && (ingenuity.parserModel as GameParserModel).getStackSymPresentFG() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_FREEGAME_STACK_FEATURE);
      dispatcher.fireEvent(eventDispatchers.SHOW_LARGE_STACK_SYMBOL_FG);
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  /**
   * Method onFirstToggle overrided to updateplayAllSymbolAnim & remove player msg event call
   */
  protected onFirstToggle(): void {
    ingenuity.configData.playAllSymbolAnim = false;
    if (this.model.getIsAutoPlayLeft()) {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
    else {
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
        if ((ingenuity.parserModel as GameParserModel).getHasFreeGamesWin() && this.model.getIsLineWins() && this.model.getWinLinesData().length > 0) {
          dispatcher.fireEvent(SlotEventConstantsBehavior.BEGIN_STAGE_CLICK);
          ingenuity.configData.enableStageClickOnFirstToggle = true;
        }
      }
      if (this.model.getIsLineWins()) {
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
          dispatcher.fireEvent(SlotEventConstants.FG_START_FIRST_TOGGLE_CYCLE);
        }
        else {
          dispatcher.fireEvent(SlotEventConstants.START_FIRST_TOGGLE_CYCLE);
        }
      }
      else {
        this.showNextWinPresentation();
      }
    }
  }

  /**
     * Method Overrided to show call onShowNextWinPresentation when no line win
     */
  protected onShowAllFrames(): void {
    if ((ingenuity.parserModel as GameParserModel).getHasLineWins()) {
      //Set total basegame win amount before bigwin so that line win tickup will not play twice(In win meter + In Bigwin)
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
        (ingenuity.parserModel as GameParserModel).setGameWinAmt((ingenuity.parserModel as GameParserModel).getCurrentSpinTotalWinAmt() - (ingenuity.parserModel as GameParserModel).getFreeSpinTotalWin());
      }
      super.onShowAllFrames()
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState && !this.model.getIsFgBigWin() && !this.model.getIsBigWin()) {
        this.enableStageClickOnWin();
      }
    } else {
      this.onShowNextWinPresentation()
    }
  }

  // to make flag true and begin stage click on normal win
  private enableStageClickOnWin(): void {
    ingenuity.configData.stageClickOnWinTickup = true;
    dispatcher.fireEvent(SlotEventConstantsBehavior.BEGIN_STAGE_CLICK);
  }
  /**
   * Method onShowBigWin to check assets during postloading. Also to hide symbol animations before bigwin
   */
  protected onShowBigWin(): void {
    if (this.model.getIsBigWin() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_BASE_GAME_POSTLOAD)) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
        setTimeout(() => {
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
    }, 10);
        this.startTheBigWinPresentation();
        dispatcher.fireEvent(SlotEventConstantsBehavior.BEGIN_STAGE_CLICK);
        dispatcher.fireEvent(SlotEventConstantsBehavior.BRING_GUI_ON_TOP);
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
        dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
        dispatcher.on(
          EventConstants.BASEGAME_POSTLOAD_ASSETS_LOADED,
          (e: IEvent) => {
            delayedCall(
              SlotConstantsBehavior.BIG_WIN_POSTLOAD,
              SlotConstantsBehavior.BIG_WIN_POSTLOAD_DELAY_INTERVAL,
              () => {
                killDelayedCall(SlotConstantsBehavior.BIG_WIN_POSTLOAD);
                this.onShowBigWin();
              },
              this
            );
          },
          this,
          true
        );
      }
    } else {
      if (this.model.getIsBigWin() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
        this.startTheBigWinPresentation();
        dispatcher.fireEvent(SlotEventConstantsBehavior.BEGIN_STAGE_CLICK);
        dispatcher.fireEvent(SlotEventConstantsBehavior.BRING_GUI_ON_TOP);
      } else {
        dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
      }
    }
  }

  /**
  * Method resetPresentationsOnSpinClick overrided to update functionality
  */
  protected resetPresentationsOnSpinClick(): void {
    if (this.model.getIsBigWinRunning()) {
      (ingenuity.parserModel as GameParserModel).setIsSpinClicked(true);
      dispatcher.fireEvent(SlotEventConstants.SUMUP_BIGWIN);
      /**to show winamount in winmeter for some time on spin click
       * reset it after some delay
       */
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.SET_WIN_VALUE_TO_DEFAULT);
    dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
    // dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_STOP_BTN);
    killDelayedCall("SHOW_SPAGHTTI");
    killDelayedCall("5OKind");
    dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
    if ((ingenuity.parserModel as GameParserModel).getFreeSpinsRemaining() > 0) {
      killDelayedCall(SlotConstantsBehavior.ClearBigWinCompleteDelayer);
      delayedCall(SlotConstantsBehavior.ClearBigWinCompleteDelayer, SlotConstantsBehavior.ClearBigWinCompleteTimer / 2, () => {
        this.onFreeSpinPresentation();
      });
    }
    else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAYER_MSG_SPIN_CLICK);
      if (!this.model.getIsBigWinRunning() && !ingenuity.configData.isForceStopDuringPot) {
        this.processingSpinClicked();
        this.model.setIsBigWinRunning(false);
      }
    }
    ingenuity.configData.isPlayAnticipationSound = false;
    ingenuity.configData.spinStopPressed = false;
  }


  //adding getIsSpecialSymbolAvailable with win to continue showNextWinPresentation
  protected onCheckForWinAfterReelStop(evt: IEvent) {
    if ((ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered() || (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered()) {
      dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
      dispatcher.fireEvent(SlotEventConstants.SHOW_SPIN_BTN_HIDE_STOP_BTN);
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_SPIN_BTN_HIDE_STOP_BTN);
    }
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_SPIN_BTN_HIDE_STOP_BTN);
    }
    if ((ingenuity.parserModel as GameParserModel).getFreeSpinsRemaining() > 0 && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      this.setWinlineAndWaysData();
      killDelayedCall(SlotConstantsBehavior.BROKEN_DELAY_FG);
      this.showNextWinPresentation();
    } else if (this.model.getIsWin() && ingenuity.parserModel.getTotalWin() || (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered()) {
      this.setWinlineAndWaysData();
      killDelayedCall(SlotConstantsBehavior.BROKEN_DELAY_FG);
      this.showNextWinPresentation();
    }
    else {
      killDelayedCall(SlotConstantsBehavior.NoWinDelay);
      delayedCall(SlotConstantsBehavior.NoWinDelay, SlotConstantsBehavior.setDelayForNoWin, () => {
        dispatcher.fireEvent(SlotEventConstants.SHOW_CONTAINERS, SlotConstantsBehavior.ButtonsContainerId);
      });
    }
    (ingenuity.parserModel as GameParserModel).setisSpinStarted(false);
  }

  /**
  * Method to show top jackpot panel meter values
  */
  private jackpotTopPanelAnim(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsJackpotAward()) {
      delayedCall("awradJPWithDelay", 1000, () => {
        killDelayedCall("awradJPWithDelay");
        dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
        dispatcher.fireEvent(SlotEventConstants.FG_SUSPEND_WINPRESENTATION);
        dispatcher.fireEvent(eventDispatchers.AWARD_JACKPOT_FG);
      }, this);
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  /**
 * Method to play scatter triggering animation
 */
  protected onTriggeringAnimation(): void {
    ingenuity.configData.enableStageClickOnFirstToggle = false;
    dispatcher.fireEvent(SlotEventConstantsBehavior.DISABLE_STAGE_CLICK);
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState && this.model.getIsScatterWins() && (ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered()) {
      this.startScatterPresentation();
    }
    else if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState && (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
      dispatcher.fireEvent(SlotEventConstants.FG_SUSPEND_WINPRESENTATION);
      this.startScatterPresentation();
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_FREE_GAME_WIN_METER);
    }
    else {
      this.showNextWinPresentation();
    }
  }

  /**
   * Method onSpinClicked overided to update functionality
   */
  protected onSpinClickedInFreeGame(evt: IEvent): void {
    super.onSpinClickedInFreeGame(evt);
    ingenuity.configData.spinComplete = false;
    (ingenuity.parserModel as GameParserModel).setCommonOffsetsOfStackAndWin([]);
    dispatcher.fireEvent(eventDispatchers.RESET_SCATTER_DATA_FG);
  }

  /**
   * Method onSpinClicked overided to update functionality
   */
  protected onSpinClicked(evt: IEvent): void {
    super.onSpinClicked(evt);
    (ingenuity.parserModel as GameParserModel).setCommonOffsetsOfStackAndWin([]);
    dispatcher.fireEvent(eventDispatchers.RESET_SCATTER_DATA);
    this.playReelSpinSound();
    this.fadeBaseGameSound();

  }

  /**
   * Method playReelSpinSound to play reel spin sound
   */
  private playReelSpinSound(): void {
    const audioController: any = (ingenuity.soundManager as any);
    if (!audioController.getSoundInstance(SoundConstantGame.MUSIC_SPIN, "soundList") && !ingenuity.configData.isReelSpinMusicPlaying) {
      this.playMusicSpin();
    }
  }

  /**
  * Method to play reel spin sound if no win
  */
  private playMusicSpin():void {
        ingenuity.configData.isReelSpinMusicPlaying = true;
       const audioController: any = (ingenuity.soundManager as any);
        audioController.stop(SoundConstantGame.MUSIC_SPIN, "soundList");
        audioController.playSound(SoundConstantGame.MUSIC_SPIN, gameConstants.FULL_VOLUME, false);
        audioController.getSoundInstance(SoundConstantGame.MUSIC_SPIN).onMarkerComplete.addOnce(() => {
            if (ingenuity.currentGame.state.getCurrentState().key !== SlotConstantsBehavior.freeGameState) {
                if ((ingenuity.parserModel as GameParserModel).getHasWin() || this.model.isReelSpinning()) {
                    this.playMusicSpin();
                }
                else {
                    ingenuity.configData.isReelSpinMusicPlaying = false;
                    if (audioController.getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, SlotConstantsBehavior.SOUND_LIST_PRELOAD)) {
                        audioController.getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, SlotConstantsBehavior.SOUND_LIST_PRELOAD).volume = 1;
                    }
                    else {
                        audioController.playSound(SoundConstant.BASEGAME_BGMLOOP, 1, true, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
                    }
                }
            }
        }, this);
    }

  /**
 * Method fadeBaseGameSound to fade and stop base game BGM and intro sound.
 */
  private fadeBaseGameSound(): void {
    const audioController: any = (ingenuity.soundManager as any);
    if (audioController.getSoundInstance(SoundConstantGame.BASEGAME_BGM_INTRO, gameConstants.SOUND_LIST_PRELOAD)) {
      audioController.stop(SoundConstant.BASEGAME_BGM_INTRO, gameConstants.SOUND_LIST_PRELOAD);
    };
    if (audioController.getSoundInstance(SoundConstantGame.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD)) {
      audioController.getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD).volume = gameConstants.LOW_VOLUME;
    } else {
      audioController.playSound(SoundConstant.BASEGAME_BGMLOOP, gameConstants.LOW_VOLUME, true, gameConstants.SOUND_LIST_PRELOAD);
    };
  }

  /**
   * Method to show prize on pot.
   */
  private magicPotionPrizePresentation(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsMagicPotionBG() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(eventDispatchers.MAGIC_POTION_START);
      this.enableStageClickDuringPot();
    }
    else if ((ingenuity.parserModel as GameParserModel).getIsMagicPotionFG() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(eventDispatchers.MAGIC_POTION_START_FG);
      this.enableStageClickDuringPot();
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  /**
 * Method enableStageClickDuringPot to enable stage click.
 */
  private enableStageClickDuringPot(): void {
    ingenuity.configData.stageClickDuringPotConversion = true;
    dispatcher.fireEvent(SlotEventConstantsBehavior.BEGIN_STAGE_CLICK);
  }

  /**
   * Method to convert pot symbol into jackpot symbol.
   */
  private magicPotionWithJackpotPresentation(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsJackpotWonBG()) {
      dispatcher.fireEvent(eventDispatchers.MAGIC_POTION_JACKPOT_CONVERSION);
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  /**
   * Method to convert pot symbol into FS symbol.
   */
  private fsPotSymbolConversion(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsFSPotPresentBG() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(eventDispatchers.FS_POT_SYMBOL_CONVERSION);
    }
    else if ((ingenuity.parserModel as GameParserModel).getRetriggerWithExtraSpin() && (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(eventDispatchers.FS_POT_SYMBOL_CONVERSION_FG);
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  /**
   * Method to show jackpot banner presentation.
   */
  private showJackpotBannerPresentation(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsJackpotWonBG()) {
      if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_BASE_GAME_POSTLOAD)) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
        dispatcher.fireEvent(eventDispatchers.INITIALIZE_JACKPOT_PRESENTATION);
        dispatcher.fireEvent(eventDispatchers.SHOW_JACKPOT_BANNER);
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
        dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
        dispatcher.on(EventConstants.BASEGAME_POSTLOAD_ASSETS_LOADED, (e: IEvent) => {
          this.showJackpotBannerPresentation();
        }, this);
      }

    }
    else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }

  /**
   * Method overrided to update functionality
   */
  protected sendCloseRequest(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState && !ingenuity.configData.endReqSent) {
      if (!(ingenuity.parserModel as GameParserModel).getHasFreeGamesWin()) {
        if ((ingenuity.parserModel as GameParserModel).getNoSettleOnError()) {
          (ingenuity.parserModel as GameParserModel).setNoSettleOnError(false);
          dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
        }
        else {
          dispatcher.fireEvent(PlatformEventConstants.GAME_CLOSE);
          dispatcher.fireEvent(EventConstantsLeander.TOTAL_WIN_UPDATED, { winAmount: (ingenuity.parserModel as platformModel).getCurrentSpinTotalWinAmt().toFixed(2) })
        }
        ingenuity.configData.endReqSent = true;
      }
    }
    else if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstants.DO_NEXT_SPIN);
    }
    (ingenuity.parserModel as GameParserModel).setLinesWinUniquePositions([]);
  }

  /**
   * Method resetPresentationsOnSpinClickFg overrided to update functionality
   * overrided to update setIsSpinClicked model issue
   */
  protected resetPresentationsOnSpinClickFg(): void {
    killDelayedCall("SHOW_SPAGHTTI");
    killDelayedCall(SlotConstants.TimerForNextFreeSpin);
    dispatcher.fireEvent(SlotEventConstants.FG_SUSPEND_WINPRESENTATION);
    !ingenuity.configData.isForceStopDuringPotFG && dispatcher.fireEvent(eventDispatchers.RESET_DATA_FG);
    dispatcher.fireEvent(SlotEventConstants.CLEAR_SPIN_TIMER);
    dispatcher.fireEvent(SlotEventConstants.REMOVE_ALL_LISTNERS_FROM_STAGE);
    dispatcher.fireEvent(SlotEventConstants.FG_DISABLED_ALL_BUTTONS);
    dispatcher.fireEvent(SlotEventConstants.FG_CLEAR_DATA);
    if (this.model.getFreeSpinsRemaining() === 0) {
      dispatcher.fireEvent(SlotEventConstants.DO_NEXT_SPIN);
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.VALIDATE_BET_IN_FREEGAME);
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_FREESPIN_LABEL_COUNT);
    if (this.model.getIsBigWinRunning() && !ingenuity.configData.isForceStopDuringPot) {
      (ingenuity.parserModel as GameParserModel).setIsSpinClicked(true);
    }
    ingenuity.configData.isPlayAnticipationSound = false;
    ingenuity.configData.spinStopPressed = false;
  }


  /**overrided to stop multiple onMarkerComplete Bindings. */
  protected onVisibilityChange(evt: IObject) {
    super.onVisibilityChange(evt);
    if (evt.target.visibilityState === "visible") {
      this.resumeSpinMusic();
      (gameConstants.WIN_METER_OBJECT as MeterGame).resumeTickUp();
    }
    else {
      (gameConstants.WIN_METER_OBJECT as MeterGame).pauseTickUp();
      if (ingenuity.deviceEnv.browser !== "EDGE" && ingenuity.deviceEnv.browser !== "IE10" && ingenuity.deviceEnv.browser !== "IE11") {
        const soundInstance = ingenuity.soundManager.getSoundInstance(SoundConstantGame.MUSIC_SPIN, "soundList");
        if (soundInstance && soundInstance.soundPlaying) {
          ingenuity.soundManager.pause(SoundConstantGame.MUSIC_SPIN);
          this.spinSoundPause = true;
        }
        if (!ingenuity.deviceEnv.isDesktop && (ingenuity.deviceEnv.getIsIpad() || ingenuity.deviceEnv.getDeviceOS() !== 'ios')) {
          dispatcher.fireEvent(eventDispatchers.DISABLE_FULL_SCREEN_GAME);
        }
      }
    }
  }
  /**
   * Method overrided to add grand jackpot on free game outro
   * @param evt 
   */
  protected doNextSpin(evt: IEvent): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAYER_MSG_SPIN_CLICK);
    if (!(this.model instanceof FreeGameModelBehavior && (ingenuity.parserModel as GameParserModel).getFreeSpinsRemaining())) {
      dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
    }
    if (this.model instanceof FreeGameModelBehavior && (ingenuity.parserModel as GameParserModel).getFreeSpinsRemaining()) {
      this.model.resetForSpin();
      dispatcher.fireEvent(SlotEventConstants.SPIN_CLICKED_IN_FREE_GAME);
    }
    else {
      if ((ingenuity.parserModel as GameParserModel).getIsGrandJackpotAward()) {
        this.showJackpotAfterFg();
      } else {
        this.showOutroAfterFg();
      }
    }
  }

  //Method overrided to reset freegame broken data after returning from freegame
  protected onCloseResponseReceived(evt: IEvent): void {
    if (this.model.getIsAutoPlayLeft()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_NEXT_SPIN_CALL);
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
    }
    if (ingenuity.configData.isReturningFromFreegame) {
      dispatcher.fireEvent(EventConstantsLeander.SAVE_DATA_REQUEST, (ingenuity.parserModel as GameParserModel).getUserGameCloseData());
      ingenuity.configData.isReturningFromFreegame = false;
    }
  }

  /**spin music sound presentation */
  private resumeSpinMusic(): void {
    if (ingenuity.deviceEnv.browser !== "EDGE" && ingenuity.deviceEnv.browser !== "IE10" && ingenuity.deviceEnv.browser !== "IE11") {
      if (this.spinSoundPause) {
        const audioController: any = (ingenuity.soundManager as any);
        audioController.resume(SoundConstantGame.MUSIC_SPIN, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
        this.spinSoundPause = false;
        audioController.getSoundInstance(SoundConstantGame.MUSIC_SPIN).onMarkerComplete.addOnce(() => {
          if ((ingenuity.parserModel as GameParserModel).getHasWin() || this.model.isReelSpinning()) {
            this.playMusicSpin();
          } else {
            audioController.playSound(SoundConstant.BASEGAME_BGMLOOP, 1, true, gameConstants.SOUND_LIST_PRELOAD);
          }
        }, this);
      }
    }
  }

  /**
   * Method to show Grand jackpot on outro.
   */
  private showJackpotAfterFg(): void {
    dispatcher.fireEvent(eventDispatchers.INITIALIZE_JACKPOT_PRESENTATION);
    dispatcher.fireEvent(eventDispatchers.SHOW_JACKPOT_BANNER);
  }

  /**
   * Method to show free game outro after free game grand jackpot banner
   */
  private showOutroAfterFg(): void {
    delayedCall(SlotConstants.TimerForDisplayOutro, ingenuity.configData.freeSpinTimer, function () {
      killDelayedCall(SlotConstants.TimerForDisplayOutro);
      this.unSubscribeReelPanelControllerEvents();
      dispatcher.fireEvent(SlotEventConstants.FG_SUSPEND_WINPRESENTATION);
      dispatcher.fireEvent(SlotEventConstants.UNSUBSCRIBE_FREEGAME_REELPANEL_EVENTS);
      dispatcher.fireEvent(SlotEventConstants.UNSUBSCRIBE_FREEGAME_WIN_PRESENTATION_EVENTS);
      dispatcher.off(SlotEventConstants.SUBSCRIBE_EVENTS_ON_REEL_START_FG);
      dispatcher.fireEvent(SlotEventConstants.UNSUBSCRIBE_WINPRESENTATION_PANEL_FG);
      dispatcher.fireEvent(SlotEventConstants.SCBSCRIBE_METER_CONTROLLERS_BG);
      dispatcher.fireEvent(EventConstants.STOP_SOUND, "freeGameBGMusic");
      dispatcher.fireEvent(SlotEventConstants.FG_DISABLED_ALL_BUTTONS);
      dispatcher.fireEvent(SlotEventConstantsBehavior.FG_OUTRO_SHOW);
    }, this);
  }
  protected startAutoPlayClicked(evt: IEvent) {
    ingenuity.configData.isAutoplayActive = true;
    dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
    dispatcher.fireEvent(SlotEventConstants.AUTOPLAY_COUNT, evt.data);
    dispatcher.fireEvent(SlotEventConstants.RESET_METERS);
    dispatcher.fireEvent(SlotEventConstants.CHECK_FOR_AUTOPLAY_CONDITION);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_AUTOPLAY_ON_BTN);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_AUTOPLAY_OFF_BTN);
    dispatcher.fireEvent(SlotEventConstants.UPDATE_AUTOPLAY_METERS);
    dispatcher.fireEvent(SlotEventConstants.ENABLE_BUTTON, [SlotConstantsBehavior.AutoPlayOffBtnId]);

  }

}


